<template>
  <div class="customer-list">
    <div class="customer-box">
      <rCenterHeader></rCenterHeader>
    </div>
    <div class="list-box" :style="{ minHeight: 'calc(100vh - 140px)' }">
      <div class="common-flex common-justify-between">
        <div class="common-flex common-align-center">
          <!-- <div class="sort">{{ $t("customer.sort") }}</div>
          <Select v-model="model" size="large" style="width: 247px">
            <Option
              v-for="item in typeList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select> -->
          <form>
            <Input
               @keydown.enter.native.prevent="search"
              size="large"
              search
              v-model="params.keywords"
              :placeholder="$t('fabricLibrary.search')"
              style="width: 380px"
            >
              <Icon type="ios-search" slot="suffix" />
            </Input>
          </form>
        </div>
        <div>
          <Icon
            v-if="canImport"
            class="common-hover"
            @click="importCustomer"
            style="
              width: 36px;
              height: 36px;
              line-height: 36px;
              border-radius: 4px;
              background: #0a4dcc;
              color: #fff;
              margin-right: 10px;
            "
            type="md-cloud-upload"
          />
          <input 
            type="file" 
            ref="fileInput" 
            accept=".csv" 
            style="display: none;" 
            @change="handleFileChange" 
          />
          <Icon
            class="common-hover"
            @click="addCustomer"
            style="
              width: 36px;
              height: 36px;
              line-height: 36px;
              border-radius: 4px;
              background: #0a4dcc;
              color: #fff;
            "
            type="md-add"
          />
        </div>
      </div>
      <div class="customer-items common-flex common-flex-wrap">
        <rCustomerItem
          @details="details"
          v-for="(item, index) in customerList"
          :config="item"
          :key="index"
          :style="[(index + 1) % 6 == 0 ? { marginRight: 0 } : {}]"
        ></rCustomerItem>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
      <rNull
        v-if="customerList.length == 0 && spinShow == false"
        imgStyle="width:300px;margin:0 auto"
        titleStyle="font-size:16px;color:#999"
        :title="$t('noResult')"
      ></rNull>
    </div>
    <rAddNewCustomer
      :addNew="addNew"
      @handlerAdd="handlerAdd"
      @updateList="updateList"
    ></rAddNewCustomer>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import rCenterHeader from "../../components/r-center-header";
import rCustomerItem from "../../components/r-customer-item";
import rAddNewCustomer from "../../components/r-add-new-customer";
import rNull from "../../components/r-null";
import { getToken } from "../../libs/util.js";
export default {
  components: {
    rCenterHeader,
    rCustomerItem,
    rAddNewCustomer,
    rNull,
  },
  data() {
    return {
      spinShow: false,
      canImport: false, // 是否显示导入按钮
      params: {
        keywords: "",
        pageSize: 18,
        pageNum: 1,
      },
      pages: "",
      addNew: false,
      model: "appointment",
      customerList: [], //客户列表
      typeList: [
        {
          label: "Appointment",
          value: "appointment",
        },
      ],
    };
  },
  mounted() {
    this.customer();
    this.checkAccountType(); // 检查账号类型
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  },

  beforeDestroy() {
    //在组件生命周期结束的时候销毁。
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions(["customerAction", "importCustomerCsvAction", "getAccountInfoAction"]),
    
    // 检查账号类型，确定是否显示导入按钮
    checkAccountType() {
      this.getAccountInfoAction()
        .then(res => {
          if (res.code === 0 && res.data) {
            // 检查账号类型是否为TESTB或NLNBU
            const username = res.data.username;
            this.canImport = username === 'TESTB' || username === 'NLNBU';
          }
        })
        .catch(err => {
          console.error('获取账号信息失败:', err);
        });
    },
    // 搜索
    search() {
      this.params.pageNum = 1;
      this.customer();
    },
    // 滚动到底部
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      //变量windowHeight是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      // console.log("gundong", scrollTop + windowHeight, scrollHeight - 10);
      if (scrollTop + windowHeight >= scrollHeight-10) {
        //到了这个就可以进行业务逻辑加载后台数据了
        if (this.pages > this.params.pageNum) {
          this.params.pageNum++;
          this.customer();
        }
      }
    },
    // 更新列表
    updateList() {
      this.addNew = false;
      this.params.keywords = "";
      this.params.pageNum = 1;
      this.customer();
    },
    // 用户列表
    customer() {
      let that = this;
      this.spinShow = true;
      this.customerAction(this.params)
        .then((res) => {
          this.pages = res.pages;
          if (this.params.pageNum == 1) {
            this.customerList = res.data;
          } else {
            this.customerList = this.customerList.concat(res.data);
          }
        })
        .finally(function () {
          that.spinShow = false;
        });
    },
    //   客户详情
    details(e) {
      this.$router.push({
        path: "./customerDetails",
        query: {
          id: e.id,
        },
      });
    },
    handlerAdd() {
      this.addNew = false;
    },
    addCustomer() {
      this.addNew = true;
    },
    importCustomer() {
      this.$refs.fileInput.click();
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      
      // 检查文件类型
      if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
        this.$Message.error('只能上传CSV文件');
        return;
      }
      
      // 创建FormData对象
      const formData = new FormData();
      formData.append('file', file);
      
      // 显示上传中提示
      this.$Message.loading({
        content: '正在上传...',
        duration: 0
      });
      
      // 发送上传请求
      this.importCustomerCsvAction(formData)
        .then(response => {
          // 关闭提示
          this.$Message.destroy();
            // 刷新客户列表
          this.updateList();
        })
        .finally(() => {
          // 清空文件输入框，允许用户选择相同的文件
          this.$refs.fileInput.value = '';
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-select-selection {
  height: 36px;
  line-height: 36px;
  background: #f1f5fc;
  border: none;
  text-align: left;
}
/deep/.ivu-select-selection {
  height: 36px;
  line-height: 36px;
  background: #f1f5fc;
  border: none;
  text-align: left;
}
/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 36px;
  line-height: 36px;
  background: #f1f5fc;
  border: none;
  text-align: left;
}
.customer-list {
  .customer-box {
    width: 1420px;
    background: #fff;
    margin: 0 auto;
  }
  .customer-items {
    margin-top: 25px;
    position: relative;
    > div {
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }
  .list-box {
    width: 1420px;
    background: #fff;
    padding: 20px 30px;
    margin: 0 auto;
    .sort {
      margin-right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customerList/customerList.vue